import { TableHead, TableRow } from '@material-ui/core'
import SortableTableHeader from './SortableTableHeader';



const TableHeaders = ({ sortable = true, headers, handleSort, sortLabel, sortedColumn, sortDirection }) => {

  return (
    <TableHead  >
      <TableRow>
        {headers.map(header => {
          return <SortableTableHeader sortable={sortable} show={header.show} key={header.title} title={header.title} idName={header.idName} handleSort={handleSort} sortLabel={sortLabel} sortedColumn={sortedColumn} sortDirection={sortDirection} />
        })}
      </TableRow>
    </TableHead>
  );
}

export default TableHeaders;

